export enum AutohealReasonLabel {
  AutohealForceEndSession = 'AUTOHEAL_FORCE_END_SESSION',
  AutohealSetDefaultConfig = 'AUTOHEAL_SET_DEFAULT_CONIFG',
  AutohealStuckSessionTriggerMessage = 'AUTOHEAL_STUCK_SESSION_TRIGGER_MESSAGE',
  AutohealStuckSessionUnlock = 'AUTOHEAL_STUCK_SESSION_UNLOCK',
  UNKNOWN = 'AUTOHEAL_UNKNOWN',
  AutohealReservationAmountReached = 'AUTOHEAL_RESERVATION_AMOUNT_REACHED'
}
